import { render, staticRenderFns } from "./EditReservation.vue?vue&type=template&id=19c75989&scoped=true"
import script from "./EditReservation.vue?vue&type=script&lang=ts"
export * from "./EditReservation.vue?vue&type=script&lang=ts"
import style0 from "./EditReservation.vue?vue&type=style&index=0&id=19c75989&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c75989",
  null
  
)

export default component.exports